<template>

    <div>
        <template v-if="fileType==='mp3' || fileType === 'mp4'">
            <div :class="getTooltipClass()"
                 :tooltip="getTooltip()" flow="down" @click="goPreview">

                <svg viewBox="0 0 28 28">
                    <g>
                        <path d="M10.536,6.353C9.136,5.526,8,6.203,8,7.866v12.268c0,1.665,1.136,2.341,2.536,1.514l10.412-6.148
                                    c1.402-0.828,1.402-2.169,0-2.997L10.536,6.353z"></path>
                    </g>
                </svg>

            </div>
        </template>
        <template v-else>
            <template v-if="
            (has_preview && (fileType==='ppt' || fileType==='pptx'
            || fileType==='doc' || fileType==='docx'
            || fileType==='xlsx' || fileType==='xls')) || fileType==='pdf'
">

                <div :class="getTooltipClass()"
                     :tooltip="getTooltip()" flow="down" @click="goPreview">

                    <template v-if="secchi">
                        <svg viewBox="0 0 28 28">
                            <g>
                                <path d="M21.969,2c0.628,0,1.165,0.222,1.609,0.666c0.406,0.407,0.61,0.924,0.61,1.553v8.82
                                    c-0.962-0.481-2.071-0.722-3.328-0.722c-2.182,0-4.013,0.74-5.492,2.219c-1.479,1.479-2.219,3.31-2.219,5.492
                                    c0,2.145,0.74,3.957,2.219,5.436l1.109,0.943H4.219c-0.629,0-1.146-0.203-1.554-0.61c-0.018-0.019-0.037-0.038-0.055-0.056
                                    C2.203,25.308,2,24.79,2,24.188V4.219c0-0.592,0.222-1.109,0.665-1.553C3.11,2.222,3.628,2,4.219,2H21.969z M18.641,7.047V5.383
                                    h2.274v-1.22h-3.605v6.822h1.332V8.268h2.052V7.047H18.641z M10.708,4.164v6.822h2.108c0.924,0,1.701-0.314,2.329-0.943
                                    s0.944-1.479,0.944-2.551c0-2.219-1.091-3.328-3.273-3.328H10.708z M14.703,7.492c0,0.74-0.167,1.294-0.5,1.664
                                    c-0.407,0.407-0.907,0.61-1.499,0.61h-0.775V5.383h0.775c0.592,0,1.074,0.167,1.443,0.5C14.517,6.252,14.703,6.789,14.703,7.492z
                                     M5.161,4.164v6.822h1.387v-2.44h0.667C7.88,8.582,8.453,8.416,8.934,8.046c0.443-0.444,0.665-1.017,0.665-1.72
                                    c0-1.442-0.777-2.163-2.329-2.163H5.161z M7.048,7.492h-0.5V5.273h0.555c0.74,0,1.109,0.37,1.109,1.109S7.824,7.492,7.048,7.492z
                                     M20.86,25.907c-1.59,0-2.958-0.573-4.105-1.719c-1.146-1.146-1.719-2.515-1.719-4.105c0-1.589,0.573-2.958,1.719-4.104
                                    c1.147-1.146,2.515-1.72,4.105-1.72c1.589,0,2.958,0.574,4.105,1.72c1.145,1.146,1.719,2.515,1.719,4.104
                                    c0,1.294-0.333,2.386-0.999,3.273l2.94,2.94l-2.331,2.33l-3.161-3.162C22.431,25.759,21.672,25.907,20.86,25.907z M23.966,20.083
                                    c0-0.85-0.296-1.589-0.887-2.219c-0.629-0.591-1.368-0.887-2.219-0.887c-0.852,0-1.59,0.296-2.219,0.887
                                    c-0.591,0.629-0.887,1.369-0.887,2.219c0,0.851,0.296,1.591,0.887,2.219c0.628,0.593,1.367,0.888,2.219,0.888
                                    c0.851,0,1.589-0.296,2.219-0.888C23.67,21.672,23.966,20.934,23.966,20.083z"></path>
                            </g>
                        </svg>
                    </template>
                    <template v-else>

                        <svg viewBox="0 0 28 28">
                            <g>
                                <path d="M7.5,15.999c0-5.244,4.254-9.5,9.5-9.5c1.431,0,2.783,0.326,4,0.892V5c0-1.104-0.896-2-2-2H5
                                    C3.896,3,3,3.896,3,5v18c0,1.105,0.896,2,2,2h8.976C10.214,23.736,7.5,20.19,7.5,15.999z"></path>
                                <path d="M27,24l-3.792-3.792c0.815-1.199,1.292-2.648,1.292-4.209c0-4.14-3.358-7.5-7.5-7.5
                                    c-4.143,0-7.5,3.359-7.5,7.5c0,4.146,3.357,7.501,7.5,7.501c1.033,0,2.018-0.209,2.913-0.587L24,27L27,24z M13,15.999
                                    C13,13.791,14.792,12,17,12c2.209,0,4,1.791,4,3.999c0,2.211-1.791,4-4,4C14.792,19.999,13,18.21,13,15.999z"></path>
                            </g>
                        </svg>

                    </template>
                </div>
            </template>
        </template>
    </div>

</template>

<script>

    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import XAPIJS from 'xapijs';

    export default {
        name: "HkepPreviewButton",
        mixins:[common, storeMapper],
        data() {
            return {
                is_downloading: false,
                is_demo_user: is_demo_user
            }
        },
        props: {
            preview_url: {
                default: "",
                type: String
            },
            url: {
                default: "",
                type: String
            },
            allow_before_login: {
                default: "Y",
                type: String
            },
            has_preview: {
                default: false,
                type: Boolean
            },
            fileType: {
                default: "",
                type: String
            },
            id: {
                default: "",
                type: String
            },
            item: {
                default: {}
            },
            secchi: {
                default: false
            }
        },
        mounted() {
        },
        methods: {
            getTooltipClass()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return "preview-type dark demo-btn";
                }
                return "preview-type dark";
            },
            getTooltip()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return this.lang(this.$t('Authorization required preview')).toLowerCase();
                }
                return this.lang(this.$t('View')).toLowerCase();
            },
            goPreview()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return false;
                }

                let self = this;
                let allow = false;
                if (self.allow_before_login === "Y") {
                    allow = true;
                } else {
                    if (self.checkIsLoggedIn()) {
                        allow = true;
                    }
                }

                if (!allow) {
                    EventBus.$emit("showLogin");

                } else {
                    if (!self.is_downloading && allow) {
                        if (((this.fileType === "mp4" && this.checkIsIOS()) || (this.fileType === "mp4" &&  this.checkIsAndroid())) && allow) {

                            var url = window.mp4Page+this.id;
                            window.open(url, "_blank");
                            self.is_downloading = false;

                        } else if (this.fileType === "mp3") {

                            EventBus.$emit("showHtml5Player", {
                                type: "audio/mpeg",
                                url: this.url
                            });
                            self.is_downloading = false;

                        } else if (this.fileType === "mp4") {

                            EventBus.$emit("showVideo", this.url);
                            self.is_downloading = false;

                        } else if (this.fileType === "pdf") {

                            EventBus.$emit("readPDF", {
                                'preview': this.url,
                                'url': this.url
                            });
                            self.is_downloading = false;

                        } else {
                            EventBus.$emit("readPDF", {
                                'preview': this.preview_url,
                                'url': this.url
                            });
                            self.is_downloading = false;
                        }

                        let xapijs = new XAPIJS(xapi_config, access_token);

                        xapijs.interacted(
                            display_name,
                            membercode,
                            window.location.href,
                            "檢視"
                        );

                    }

                }

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HkepPreviewButton.vue